import DownloadButton from '@/components/base-components/buttons/DownloadButton.vue';
import XMarkIcon from '@/assets/img/XMarkIcon.vue';
import TrashIcon from '@/assets/img/trashIcon.vue';
import PlayIcon from '@/assets/img/playIcon.vue';
import HourglassIcon from '@/assets/img/hourglassIcon.vue';
import DownloadIcon from '@/assets/img/downloadIcon.vue';
import ButtonComponent from '@/components/base-components/buttons/ButtonComponent.vue';
import shareIcon from '@/assets/img/shareIcon.vue';
import {CLIP_STATUSES} from '@/const';
import {mapActions} from 'vuex';
import {ADD_POPUP} from '@/store/actionTypes';
import AppLink from '@/components/base-components/AppLink.vue';
import {timestampFromTimeString} from '@/utils/injections';

export default {
  name: 'ClipItem',
  components: {
    AppLink,
    DownloadButton,
    XMarkIcon,
    TrashIcon,
    PlayIcon,
    HourglassIcon,
    DownloadIcon,
    ButtonComponent,
    shareIcon,
  },
  props: {
    clip: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      timeoutId: null,
    };
  },
  computed: {
    processing() {
      return this.clip.status === CLIP_STATUSES.processing;
    },
    success() {
      return this.clip.status === CLIP_STATUSES.success;
    },
    duration() {
      return this.clip.duration.split(':').splice(1, 2).join(':');
    },
    clipCreatedTime() {
      return this.getFormattedDate({
        ts: timestampFromTimeString(this.clip.created_at),
        formatsOptions: {
          month: {month: 'short'},
          day: {day: '2-digit'},
          hh: {
            hour: '2-digit',
            hourCycle: 'h12',
            minute: '2-digit',
          },
        },
      });
    },
  },
  methods: {
    ...mapActions({
      addPopup: ADD_POPUP,
    }),
    showPopup(eventId) {
      this.addPopup({
        component: './ShareClipPopup.vue',
        clip: this.clip,
        eventId: eventId,
      });
    },
    deleteClip() {
      this.$emit('delete', this.clip);
    },
  },
};
